module.exports = __webpack_public_path__ + "img/marker-icon-pink.d7657a9f.png";